import $ from "jquery"

$(function () {
  $(document).on("scroll", function () {
    var $nav = $(".boot-nav")
    $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height())
  })
})
